<template>
    <div style="margin-left: -1px">
        <div v-text-lbl="'cbUrgedPerson'" style="padding-left: 4px">处理人</div>
        <div v-if="loading" v-loading="loading" class="el-dialog__body" />
        <el-table v-if="!loading" :data="tableData" class="wfNodelog-container todo-row" border style="width: 100%" height="300">
            <el-table-column :label="$tx('fields.index', '序号')" type="index" width="45" align="center" />
            <el-table-column :label="$tx('gwgl.components.fields.cbUrgedPerson', '处理人')" prop="cbUrgedPerson" width="80" align="center" />
            <el-table-column :label="$tx('gwgl.components.fields.jsTime', '送达时间')" prop="jsTime" width="150" align="center" />
            <el-table-column :label="$tx('gwgl.components.fields.banwenTime', '办理时间')" prop="banwenTime" width="150" align="center" />
            <el-table-column :label="$tx('gwgl.components.fields.wfNodeNames', '处理环节')" prop="wfNodeNames" width="" align="center" />
        </el-table>
    </div>
</template>

<script>
export default {
    components: {},
    props: {
        vo: {
            type: Object,
            default: function () {
                return {}
            }
        }
    },
    data() {
        return {
            i18npkg: 'gwgl',
            moduleCode: 'components',
            loading: false,
            tableData: []
        }
    },
    computed: {},
    watch: {},
    created() {
        this.queryData()
    },
    mounted() {},
    beforeDestroy() {},
    methods: {
        async queryData() {
            this.$http({
                method: 'POST',
                contentType: 'application/x-www-form-urlencoded',
                params: {
                    orderBy: 'jsTime asc'
                },
                data: [
                    {
                        compare: '=',
                        field: 'cbId',
                        merge: true,
                        value: this.vo.id
                    }
                ],
                url: '/cuiban/cbjsjl/querydata'
            }).then((res) => {
                if (res.code === 'success') {
                    console.log(res)
                    this.tableData = res.body.listdata
                } else {
                    this.$alert(res.message, this.$tx('common.operationTip', '操作提示'), { type: 'error' })
                }
            })
        }
    }
}
</script>

<style scoped lang="scss">
</style>
